<template>
  <v-dialog @click:outside="onCancel" v-model="visible" persistent max-width="600px">
    <div v-if="isLoading">
      <dynameat-spinner/>
      <p class="text-center">{{ title }}</p>
    </div>
    <transition name="fade">
      <v-card v-if="!isLoading" class="px-5 py-4">
        <v-card-title class="headline pa-0 mb-1">{{ title }}</v-card-title>
        <v-card-text class="pa-0 mb-5">{{ description }}</v-card-text>
        <dynameat-modal-buttons @cancel="onCancel" @confirm="onConfirm"
                                :confirmText="confirmText" :cancelText="cancelText"/>
      </v-card>
    </transition>
  </v-dialog>
</template>

<script>

import Component from 'vue-class-component';
import Vue from 'vue';
import { Components } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';
import DynameatSpinner from '@dynameat/components/DynameatSpinner';
import DynameatModalButtons from '@dynameat/components/DynameatModalButtons';

@Component
@Components({ DynameatSpinner, DynameatModalButtons })
export default class DynameatConfirmationModal extends Vue {
  @Prop({ type: String, default: '' }) title;

  @Prop({ type: String }) description;

  @Prop({ Boolean, default: false }) isLoading;

  @Prop({ type: String, default() { return this.$t('cancel'); } }) cancelText;

  @Prop({ type: String, default() { return this.$t('confirm'); } }) confirmText;

  @Prop({ type: Boolean, default: false }) visible;

  onCancel() {
    if (!this.isLoading) this.$emit('cancel');
  }

  onConfirm() {
    this.$emit('confirm');
  }
}
</script>

<style>
.v-dialog--active {
  background: white;
}
</style>

<style scoped>
.headline {
  word-break: break-word;
}
.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
